const GOOGLE_MAPS_SCRIPT_ID = "google-maps-script";

let googleMapsPromise = null;

export const loadGoogleMaps = () => {
 if (googleMapsPromise) {
 return googleMapsPromise;
 }

 googleMapsPromise = new Promise((resolve, reject) => {
 // Already loaded
 if (window.google?.maps?.places) {
 resolve(window.google);
 return;
 }

 const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

 if (!apiKey) {
 reject(new Error("Google Maps API key missing"));
 return;
 }

 // Global callback
 window.initGoogleMaps = () => {
 if (window.google?.maps?.places) {
 resolve(window.google);
 } else {
 reject(new Error("Google Places library failed to load"));
 }
 };

 // Existing script
 const existingScript = document.getElementById(
 GOOGLE_MAPS_SCRIPT_ID,
 );

 if (existingScript) {
 const interval = setInterval(() => {
 if (window.google?.maps?.places) {
 clearInterval(interval);
 resolve(window.google);
 }
 }, 300);

 setTimeout(() => {
 clearInterval(interval);
 reject(new Error("Google Maps loading timeout"));
 }, 10000);

 return;
 }

 const script = document.createElement("script");

 script.id = GOOGLE_MAPS_SCRIPT_ID;

 script.src =
 `https://maps.googleapis.com/maps/api/js` +
 `?key=${apiKey}` +
 `&libraries=places` +
 `&callback=initGoogleMaps`;

 script.async = true;
 script.defer = true;

 script.onerror = () => {
 reject(new Error("Failed to load Google Maps script"));
 };

 document.body.appendChild(script);
 });

 return googleMapsPromise;
};

export const initPlaceAutocomplete = async (
 inputRef,
 onPlaceSelect,
) => {
 try {
 await loadGoogleMaps();

 if (!inputRef?.current) {
 return null;
 }

 const autocomplete =
 new window.google.maps.places.Autocomplete(
 inputRef.current,
 {
 types: ["geocode"],
 componentRestrictions: {
 country: "in",
 },
 fields: [
 "formatted_address",
 "geometry",
 ],
 },
 );

 autocomplete.addListener(
 "place_changed",
 () => {
 const place = autocomplete.getPlace();

 if (!place?.geometry?.location) {
 return;
 }

 onPlaceSelect?.({
 formattedAddress:
 place.formatted_address || "",

 latitude:
 place.geometry.location.lat(),

 longitude:
 place.geometry.location.lng(),
 });
 },
 );

 return autocomplete;
 } catch (error) {
 console.error(
 "Google Places init error:",
 error,
 );

 return null;
 }
};